export interface IApplicationState {
    startGiantWild: boolean
    giantWildRunning: boolean
    bodyBuilderSelected: boolean
    giantWildPositions: any
}

const initialState: IApplicationState = {
    startGiantWild: false,
    giantWildRunning: false,
    bodyBuilderSelected: true,
    giantWildPositions: []
};

export enum actionTypes {
    START_GIANTWILD = '@@giantWild/START_GIANTWILD',
    GIANT_WILD_RUNNING = '@@giantWild/GIANT_WILD_RUNNING',
    CHANGE_CHARACTER = '@@giantWild/CHANGE_CHARACTER',
    SET_GIANTWILD_POSITION = '@@giantWild/SET_GIANTWILD_POSITION',
    RESET_REEL_STATE = '@@grid/RESET_REEL_STATE',
}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const { giantWildPositions, giantWildRunning, bodyBuilderSelected } = action;

    switch (action.type) {
        case actionTypes.START_GIANTWILD:
            return {
                ...state,
                startGiantWild: true
            };
        case actionTypes.GIANT_WILD_RUNNING:
            return {
                ...state,
                giantWildRunning: giantWildRunning
            };
        case actionTypes.CHANGE_CHARACTER:
            return {
                ...state,
                bodyBuilderSelected: bodyBuilderSelected
            };
        case actionTypes.SET_GIANTWILD_POSITION:
            return {
                ...state,
                giantWildPositions: giantWildPositions,
                startGiantWild: false,
            };
        case actionTypes.RESET_REEL_STATE:

            return {
                ...state,
                startGiantWild: false,
                giantWildRunning: false,
                giantWildPositions: []
            }
        default:
            return state;
    }
}

export const actions = {
    startGiantWild: (): any => ({ type: actionTypes.START_GIANTWILD }),
    setGiantWildRunning: (giantWildRunning: any): any => ({ type: actionTypes.GIANT_WILD_RUNNING, giantWildRunning }),
    changeCharacter: (bodyBuilderSelected: any): any => ({ type: actionTypes.CHANGE_CHARACTER, bodyBuilderSelected }),
    setGiantWildPositions: (giantWildPositions: any): any => ({
        type: actionTypes.SET_GIANTWILD_POSITION,
        giantWildPositions
    }),
};
